export const auszahlungsgrenzeEinheitAuswahl = {
  euro: 'euro',
  stunden: 'stunden',
} as const;

export type AuszahlungsgrenzeEinheitAuswahl =
  keyof typeof auszahlungsgrenzeEinheitAuswahl;
